<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" class="truck-gc-case-dialog">

  <sc-title>{{'global connect connection of option' |
    translate:['tmc.visit.overview.gc-case-dialog.title',
    translationService.language]}}</sc-title>

  <sc-separator-line></sc-separator-line>

  <sc-flex-fitting-content [vertical]="true">

    <sc-padding>

      <app-truck-info-panel [carrier]="truck.carrier" [driver]="truck.driver" [identifier]="truck.numberPlate">
      </app-truck-info-panel>

      <sc-content-spacer></sc-content-spacer>

      <sc-flex [fitHeight]="true" [centered]="true" [vertical]="true">
        <div class="qr-code-box">
          <qrcode *ngIf="truck.messagingReference" [qrdata]="truck.messagingReference" [scale]="8"></qrcode>
        </div>
      </sc-flex>

    </sc-padding>
  </sc-flex-fitting-content>

  <sc-separator-line></sc-separator-line>

  <sc-actionbar>
    <sc-content-spacer [grow]="true"></sc-content-spacer>
    <button mat-stroked-button mat-dialog-close (click)="closeDialog()">{{'cancel' |
      translate:['shared.selection-dialog.action.close',
      translationService.language]}}</button>
  </sc-actionbar>

</sc-flex>
